import React from 'react';
import { Outlet, Link } from "react-router-dom";

import './App.css';

function App() {
  return (
      <div className="viewport">
          <div className="header-pnl">
              <div className="header-title">
                  TruPlay
              </div>
              <div className="header-menu">
                  <div className="header-menu-link">
                      <Link to="/home">Home</Link>
                  </div>
                  <div className="header-menu-link">
                      <Link to="/about">About</Link>
                  </div>
                  <div className="header-menu-link">
                      <Link to="/careers">Careers</Link>
                  </div>
                  <div className="header-menu-link">
                      <Link to="/blog">Blog</Link>
                  </div>
                  <div className="header-menu-link">
                      <Link to="/contact">Contact</Link>
                  </div>
              </div>
          </div>
          <div className="body-pnl">
              <Outlet />
          </div>
      </div>
  );
}

export default App;
